export function AboutIntro() {
  return (
    <section className="py-16">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-semibold mb-6 font-serif">
          About Us
        </h2>
        <div className="space-y-5 text-gray-700 text-[15px] leading-relaxed">
          <p>
            Western Drymix, a leading manufacturer in the field of Construction Chemicals and Dry Mix Products, based in Alwar, Rajasthan, India. With a strong foundation, consistent quality, and a team of skilled professionals, we have established ourselves as a reliable partner in the industry.
          </p>
          <p>
            In the field of Building Materials and Construction Chemicals, Western Drymix has established itself as a trusted name known for consistency, innovation, and performance. The company has earned recognition for offering a wide range of ISI-marked certified products that cater to both commercial and residential infrastructure. Our product portfolio includes Tile Adhesives, Epoxy Grouts, AAC Block Adhesives, Waterproofing Compounds, Sealants, Repair Mortars, Admixtures, Wall Putty, Decorative Paints, and Plasters—all developed to meet the highest standards of durability and safety.
          </p>
        </div>
   
      </div>
    </section>
  );
}